export default __webpack_public_path__ + "static/media/tropa-de-elite.bd2f7aa8.jpg";